import type { Location } from '@/api/v4/locations.api';
import { useFetchLocationsCached } from '@/hooks/queries/use-locations.query';

import { FormSelect, type FormSelectProps } from '../ui/form-select';

export const LocationSelect = ({ ...props }: FormSelectProps) => {
  const fetchLocationsCached = useFetchLocationsCached();

  const setOptions = async (search: string) => {
    const results = await fetchLocationsCached({
      page: 1,
      search,
      type: ['continent', 'country'],
    });

    return results.map((location: Location) => ({
      value: JSON.stringify({
        id: location.id,
        type: location.type,
      }),
      label: location.shortDescription,
    }));
  };

  return (
    <FormSelect
      setOptions={setOptions}
      isMulti
      isSearchable
      hideSelectedOptions
      {...props}
    />
  );
};
